var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWorkExperience = function SvgWorkExperience(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 70"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#cc4f00",
    d: "M70 35c0 19.33-15.67 35-35 35S0 54.33 0 35 15.67 0 35 0s35 15.67 35 35"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M31.631 25.375h6.737v-3.322h-6.737zm16.843 0h-6.737v-3.322c0-1.843-1.499-3.32-3.369-3.32h-6.736c-1.87 0-3.369 1.477-3.369 3.32v3.322h-6.737c-1.869 0-3.351 1.477-3.351 3.32l-.017 18.266c0 1.843 1.499 3.32 3.368 3.32h26.948c1.869 0 3.368-1.477 3.368-3.32V28.695c0-1.843-1.499-3.32-3.368-3.32"
  }))));
};
export default SvgWorkExperience;